<template>
    <noscript>
        <div><img :src="url" style="position:absolute; left:-9999px;" alt=""/></div>
    </noscript>
</template>

<script>
    import { bus } from '../../main'

    export default {
        name: 'Metrika',
        data() {
            return {
                loaded: false
            };
        },
        computed: {
            id: function () {
                return process.env.VUE_APP_METRIKA
            },
            url: function() {
                return 'https://mc.yandex.ru/watch/' + this.id;
            },
            debug: function () {
                return process.env.VUE_APP_METRIKA_DEBUG !== 'false';
            }
        },
        mounted() {
            const self = this;

            (function (m, e, t, r, i, k, a) {
                m[i] = m[i] || function () {
                    (m[i].a = m[i].a || []).push(arguments)
                };
                m[i].l = 1 * new Date();
                k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
                k.onload = function() {
                    self.$store.commit('setAnalyticsLoaded', 'metrika');
                    self.loaded = true;
                };

                setTimeout(function() {
                    if (!self.loaded) {
                        self.$store.commit('setAnalyticsLoaded', 'metrika');
                    }
                }, 1500);
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            window.ym(self.id, "init", {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true
            });

            bus.$on('laboratoryLanding.analytics', (data) => {
                if (!self.loaded) {
                    return;
                }

                let action;
                switch (data.action) {
                    case '20sec':
                        action = 'ViewContent';
                        break;
                    case 'loadAttachments':
                        action = 'InitiateCheckout';
                        break;
                }

                if (!action) {
                    return;
                }

                const params = {};
                if (self.$store.state.analyticsLandingParameter) {
                    params.service = self.$store.state.analyticsLandingParameter;
                }

                if (!self.debug) {
                    window.ym(self.id, 'reachGoal', action, params, function () {
                        console.debug('yandex metrika send event:', action, params, self.debug);
                    });
                } else {
                    console.debug('yandex metrika send event:', action, params, self.debug);
                }
            });
        },
    }
</script>
